import {Component, OnInit, ViewChild} from '@angular/core';
import {Kit, KitChange, KitService, KitStatus} from "../../services/kit.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {UtilService} from "../../services/util.service";
import {finalize, mergeMap, tap} from "rxjs/operators";
import {KitStatusDialogComponent} from "../../dialogs/kit-status-dialog/kit-status-dialog.component";
import {of} from "rxjs";
import {Utils} from "../../util/utils";

@Component({
    templateUrl: './kits.component.html',
    styleUrls: ['./kits.component.css']
})
export class KitsComponent implements OnInit {

    readonly columnsToDisplay = ['email', 'code', 'updated', 'status', 'actions'];
    readonly INITIAL_PAGE_INDEX = 0;
    readonly INITIAL_PAGE_SIZE = 10;

    @ViewChild('paginator') paginator: MatPaginator;
    initializing: boolean = false;
    total: number = 0;
    kits: Kit[] = [];
    kitRange: Kit[] = [];

    constructor(private kitService: KitService,
                private utilService: UtilService) {
    }

    ngOnInit() {
        this.refresh();
    }

    private refresh() {
        this.initializing = true;
        this.kitService.getAll(0, 300).pipe(
            finalize(() => {this.initializing=false})
        ).subscribe((bundle) => {
            this.total = bundle.total;
            this.kits = bundle.results;
            this.updateKitRange();
        }, this.utilService.getErrorHandler("Error retrieving kits"));
    }

    private updateKitRange() {
        const pageSize = this.paginator? this.paginator.pageSize : this.INITIAL_PAGE_SIZE;
        const pageIndex = this.paginator? this.paginator.pageIndex : this.INITIAL_PAGE_INDEX;
        const offset = pageIndex * pageSize;
        this.kitRange = this.kits.slice(offset, offset + pageSize);
    }

    pageChanged(ev: PageEvent) {
        this.updateKitRange();
    }

    editStatus(kit: Kit) {
        this.utilService.openDialog<KitStatusDialogComponent, KitChange, Kit>(KitStatusDialogComponent, { data: kit })
        .pipe(
            tap(() => {
                this.initializing = true;
            }),
            mergeMap((change: KitChange) => {
                return change? this.kitService.update(kit, change) : of(false);
            }),
            finalize(() => {
                this.initializing = false;
            })
        ).subscribe((ok) => {
            this.refresh();
        }, this.utilService.getErrorHandler("Error updating kit status"));
    }

    private formatCode(code: string): string {
        let groups: string[] = [];
        for (let k=0; k<code.length; k+=3)
            groups.push(code.substr(k, 3));
        return groups.join(' ');
    }

    formatUpdatedAsLocal(kit: Kit): string {
        return Utils.AsUsTimestamp(kit.updated);
    }
}
